import invalidateAdminPlaybooksQueries from '@/hooks/admin/playbooks/helpers/invalidateAdminPlaybooksQueries';
import eventMatchesPlaybookLifecycleTool from '../helpers/eventMatchesPlaybookLifecycleTool';
import type {
    BuildRefetchAdminPlaybooksOnMutationSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const buildRefetchAdminPlaybooksOnMutationSubscription = (
    _params: BuildRefetchAdminPlaybooksOnMutationSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-admin-playbooks-on-mutation',
        routePattern: '*',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event }) => eventMatchesPlaybookLifecycleTool({ event }),
        action: ({ queryClient }) => {
            invalidateAdminPlaybooksQueries({ queryClient });
        },
    };
};

export default buildRefetchAdminPlaybooksOnMutationSubscription;
